import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import NavbarPage from "./component/navigation/navbar";
// import {fetchDataByRatings, fetchDataByPopularity, fetchDataByRelease} from './context/discover_data'
// import SideNavPage from "./component/navigation/sidenav";
import { MDBContainer } from "mdbreact";
import "./App.css";
import MovieDataContextProvider from "./context/discover_data";
import MovieDetailsContextProvider from "./context/detailInfo";
import SortByGenreContextProvider, {
  SortByGenreContext,
} from "./context/sortByGenre";
import FrontPage from './component/FrontPage'
import DiscoverMovies from "./component/Movies/DiscoverMovies";
import showDetails from "./component/Movies/showDetails";
import Error from "./component/Error";

// import GetGenre from "./component/Sort/GetGenre"
const App = () => {
  return (
    <React.Fragment>
      
        <MovieDetailsContextProvider>
        <SortByGenreContextProvider>

          <MovieDataContextProvider>
            <NavbarPage />
           
            <Switch>
              
                <Route
                  path="/"
                  exact
                  component={FrontPage}
                />
          
              
                <Route path="/sort/:genre" exact component={DiscoverMovies} />
                <Route
                  path="/discover/:name"
                  exact
                  component={DiscoverMovies}
                />
                <Route path="/details/:movieId" exact component={showDetails} />
                <Route path="/search/:search" exact component={DiscoverMovies}/>
                <Route path="/error" exact component={Error} />
                <Route render={()=>(<h1>Page Not Found</h1>)} />
              </Switch>
             
            </MovieDataContextProvider>

            </SortByGenreContextProvider>
        </MovieDetailsContextProvider>
     
    </React.Fragment>
  );
};

export default App;
